angular.module('zc.projects')
  .controller('zcNoPublishPageTypeCsvController', zcNoPublishPageTypeCsvController);

zcNoPublishPageTypeCsvController.$inject = ['$scope', 'Project'];
function zcNoPublishPageTypeCsvController($scope, Project) {
  $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    Project.uploadPageTypes({
      projectId: $scope.project.id,
      page_type: 'no_publish',
    }, {
      file: flowFile.file
    }).then(function(pageTypesResponse) {
      const pageTypes = _.filter(pageTypesResponse, { page_type: 'no_publish' });
      $scope.$emit('uploadedPageTypes', pageTypes);
    });

  });
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/campaign/no_publish_page_type_csv.controller.js